// Salesforce-compatible disqualification values shared by the lead form and action modal.
export const SUB_DISQUALIFICATION_REASONS_BY_REASON = {
  'Program Eligibility': ['Language', 'Location', 'No SMS Capability', 'On Another RPM'],
  'Insurance Eligibility': [
    'Medicare Plan Not Covered',
    'Not on Medicare',
    'In process of switching plans',
    'Unable to verify',
  ],
  'Clinical Eligibility': [
    'A1c below 5.7',
    'Blind',
    'Deceased',
    'No Diabetes diagnosis',
    'Palliative/Hospice',
  ],
  'Not Interested': [
    'Checking with PCP/Plan (No SCB)',
    'Concern with program cost',
    'Do Not Call',
    'Refused to finger prick',
    "Refused to switch to Perry's device",
    'Refused to verify identity (Aetna)',
    'Satisfied with current care',
    'Verbally declined, hung up',
  ],
  'Unable to Connect': [
    'Phone - Out of Service',
    'Unable to contact after max attempts',
    'Wrong Number',
    'Low Quality Transfer',
  ],
  'Auto-closure': [],
};

export const DISQUALIFICATION_REASON_OPTIONS = Object.keys(
  SUB_DISQUALIFICATION_REASONS_BY_REASON,
).map((reason) => ({ label: reason, value: reason }));

export const subDisqualificationReasonsFor = (reason) =>
  SUB_DISQUALIFICATION_REASONS_BY_REASON[`${reason || ''}`.trim()] || [];
